export default __webpack_public_path__ + "static/B0254-c06864b760b5f826c3a8ddb2fa559b2b.png";